import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { AxiosError } from 'axios';
import { API } from 'network/api';

export type deleteUserErrorArgs = {
  errorKey: string;
  message: string;
};

type DeleteUserConfig = {
  onSuccess?: () => void;
  onError?: (error: deleteUserErrorArgs) => void;
};

const useDeleteUser = (config?: DeleteUserConfig) => {
  const mutation = useMutation({
    mutationFn: (id: string) => API.post(`/user/delete/${id}`),
    onSuccess: () => {
      message.success('User successfully deleted');
      config?.onSuccess?.();
    },
    onError: (error) => {
      if (!(error instanceof AxiosError)) {
        message.error('Failed to delete user. Please try again.');
        return;
      }
      const { errorKey, title } = { ...error?.response?.data };
      if (errorKey === 'hasSubordinate' || errorKey === 'hasFarmerGroup') {
        config?.onError?.({
          errorKey: errorKey,
          message: title,
        });
        return;
      }
      message.error(error?.response?.data?.title ?? error?.message);
    },
  });

  return mutation;
};

export default useDeleteUser;
